module.exports = __webpack_public_path__ + "static/media/icon_menu.c8958c5f.svg";